import * as React from 'react';
import {FormattedMessage} from '@meiko/react-intl';
import {fullName} from 'utils/people';
import ContentEmpty from 'components/generic/ContentEmpty';
import Panel from './Panel';
import PanelRow from './PanelRow';

export default function ClientPanel({client, lead}) {
	// Merge lead and client information
	// Client information has priority over lead information
	const mergedClient = {
		...(lead
			? {
					firstName: lead.clientFirstName,
					lastName: lead.clientLastName,
					email: lead.email,
					phone: lead.phone,
			  }
			: {}),
		...(client ? client : {}),
	};

	return (
		<Panel title={<FormattedMessage id="Client information" />}>
			{!mergedClient ? (
				<ContentEmpty message={<FormattedMessage id="No client" />} />
			) : (
				<div className="overflow-x-auto flex flex-col">
					<PanelRow
						label={<FormattedMessage id="Name" />}
						value={fullName(mergedClient)}
					/>
					<PanelRow
						label={<FormattedMessage id="Email address" />}
						value={mergedClient.email}
					/>
					<PanelRow label={<FormattedMessage id="Phone" />} value={mergedClient.phone} />
				</div>
			)}
		</Panel>
	);
}
